import React, { useEffect, useState, useContext, useRef } from "react";
import 'react-tabs/style/react-tabs.css';
import { Header } from "../../../components/Header";
import { Menu } from "../../../components/Menu";
import { MenuPage } from "../../../components/MenuPage";
import { StyledDefaultPage } from "../../../styled-components/StyledDefaultPage.style";
import { StyledForm } from "../../../styled-components/StyledForm.style";
import { DynamicInput } from "../../../components/DynamicInput";
import { DynamicSelect } from "../../../components/DynamicSelect";
import { Footer } from "../../../components/Footer";
import { StldRow } from "../../../styled-components/StldRow.style";
import { useForm } from 'react-hook-form';
import api from '../../../services/api';
import { MobileContext } from "../../../contexts/MobileContext";
import "react-datepicker/dist/react-datepicker.css";
import "bootstrap/dist/css/bootstrap.min.css";
import * as moment from 'moment'
import DatePicker from 'react-datepicker';
import Flex from '@react-css/flex';
import { StyledTablePage } from "../../../styled-components/StyledTablePage.style";
import { StldColumn } from "../../../styled-components/StldColumn.style";
import { IconRefresh } from "../../../svg";
import { PaginationCustom } from "../../../components/PaginationCustom";
import { CardAvisos } from "../../../components/CardAvisos";
import { genericList } from "../../../services/genericList";
import Swal from "sweetalert2";

const getLista = async (formValues, currentPage, pageSize) => {
    let list = null;
    let params = `Start=${currentPage}&Length=${pageSize}`;

    if (formValues.assunto?.length >= 3) {
        params += `&Assunto=${formValues.assunto}`;
    }

    if (formValues.exibicao > 0) {
        params += `&Exibicao=${formValues.exibicao}`;
    }

    if (formValues.tipo > 0) {
        params += `&Tipo=${formValues.tipo}`;
    }

    if (formValues.inicio) {
        params += `&Inicio=${moment(formValues.inicio).startOf('day').format('YYYY-MM-DD HH:mm')}`;
    }

    if (formValues.fim) {
        params += `&Fim=${moment(formValues.fim).endOf('day').format('YYYY-MM-DD HH:mm')}`;
    }

    try {
        const response = await api.get(`avisos?${params}`);
        list = response.data;
        return list;
    } catch (err) {
        return list;
    }
}


const updateLeitura = async (dataObj) => {
    return api.put(`Avisos/marcarLido`, dataObj);
};



const updateLeituraAll = async (dataObj) => {
    return api.put(`Avisos/marcarTodosLido`, dataObj);
};



export const Avisos = () => {
    const isMobile = useContext(MobileContext);
    const isDesktop = !isMobile;
    const [AvisosData, setAvisosData] = useState(null);
    const { register, handleSubmit, reset } = useForm();
    var [isLoading, setisLoading] = useState(false);
    var [exibicao, setExibicao] = useState(null);
    var [idExibicao, setIdExibicao] = useState(null);
    var [tipoAviso, setTipoAviso] = useState(null);
    var [idTipoAviso, setIdTipoAviso] = useState(null);
    var [assunto, setAssunto] = useState(null);
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndtDate] = useState(null);
    var [searchReadOnly, setSearchReadOnly] = useState(false);
    const [exibicaoList, setExibicaoList] = useState([]);
    const [tipoList, setTipoList] = useState([]);

    //paginação;
    var [pageSize, setPageSize] = useState(10);
    const [currentPage, setCurrentPage] = useState(0);

    const loadTable = async (data, currentPage, pageSize) => {
        let formValues = {
            assunto: assunto ?? null,
            exibicao: idExibicao ?? null,
            tipo: idTipoAviso ?? null,
            inicio: startDate,
            fim: endDate,
        };

        setisLoading(true)
        const lista = await getLista(formValues, currentPage, pageSize);
        setAvisosData(lista);
        setisLoading(false)
    }

    const getExibicao = (currentValue, value) => {

        if (value === null || value === "") {
            exibicao = null;
            idExibicao = null;
            setExibicao(exibicao);
            setIdExibicao(idExibicao);
            return;
        }

        var ExibicaoResult = exibicaoList.filter(function (o) {
            return o.key === parseInt(value, 10);
        });
        exibicao = ExibicaoResult[0].value;
        idExibicao = ExibicaoResult[0].key;
        setExibicao(exibicao);
        setIdExibicao(idExibicao);
    };


    const getTipoAviso = (currentValue, value) => {

        if (value === null || value === "") {
            tipoAviso = null;
            idTipoAviso = null;
            setTipoAviso(tipoAviso);
            setIdTipoAviso(idTipoAviso);
            return;
        }

        var TipoAvisoResult = tipoList.filter(function (o) {
            return o.key === parseInt(value, 10);
        });
        tipoAviso = TipoAvisoResult[0].value;
        idTipoAviso = TipoAvisoResult[0].key;
        setTipoAviso(tipoAviso);
        setIdTipoAviso(idTipoAviso);
    };


    useEffect(() => {
        const asyncFn = async () => {
            const tipoList = await genericList(46);
            if (!!tipoList) {
                setTipoList(tipoList)
            }


            const exibicaoList = await genericList(47);
            if (!!exibicaoList) {
                setExibicaoList(exibicaoList)
            }

            loadTable(null, 0, 10);
        }

        asyncFn();
    }, []);

    const refreshData = async () => {
        loadTable(null, 0, 10);
    }

    const getSearch = async (currentValue, value, pageSize) => {
        setAssunto(currentValue);
        loadTable(null, 0, 10);
    }

    const formData = async (currentValue, value, pageSize) => {
        loadTable(null, 0, 10);
    }

    const handleStartDateChange = (date) => {
        setStartDate(date);
    }

    const handleEndDateChange = (date) => {
        setEndtDate(date);
    }

    const setMarcarLido = (id, isLido) => {
        updateLeitura({ idNotificacaoUsuarioList: [id], marcarLido: isLido }).then((response) => {
            refreshData();
            alertMsg('Sucesso', isLido ? 'Aviso Marcado como Lido' : 'Aviso Marcado como Não Lido', true);
        }).catch((error) => {
            const errorMsg = error?.response?.data?.notification?.messageReturn ? error.response.data.notification.messageReturn : 'Verifique as informações e tente novamente.';
            alertMsg('Erro', errorMsg, false);
        });
    }


    const getAllIdsList = () => {

        const newlistIds = [];
        AvisosData?.data?.itens?.map((avisoObject, index) => {
            newlistIds.push(avisoObject.idNotificacaoUsuario);
        })
        return newlistIds;
    }


    const setMarcarTodos = () => {
        if (AvisosData?.data?.itens?.length === 0
        ) {
            return;
        }

        const dataObj = {
            marcarLido: true,
            idNotificacaoUsuarioList: getAllIdsList(),
        }

        console.log(dataObj);


        updateLeituraAll(dataObj).then((response) => {
            refreshData();
            alertMsg('Sucesso', 'Os Avisos Foram Marcados como Lidos', true);
        }).catch((error) => {
            const errorMsg = error?.response?.data?.notification?.messageReturn ? error.response.data.notification.messageReturn : 'Verifique as informações e tente novamente.';
            alertMsg('Erro', errorMsg, false);
        });
    }

    const alertMsg = (title, text, type) => {
        Swal.fire({
            title: title,
            text: text,
            icon: type ? "success" : "error",
            timer: type ? 2000 : 7000,
            showConfirmButton: type ? false : true
        });
    };

    return (
        <section>
            <main className="d-flex">
                {(() => {
                    if (isDesktop) {
                        return (
                            <Menu></Menu>
                        )
                    }
                    return null
                })()}
                <StyledDefaultPage>
                    <div className="w-100 d-flex justify-content-between align-items-center">
                        <div className="title-row">
                            <h5 className="title-row-header">Avisos </h5>
                            <span title="Atualizar" className="cursorPointer" onClick={refreshData}><IconRefresh color={"#EE4B21"} /></span>
                        </div>
                    </div>
                    <div className="card">
                        <div className="row justify-content-between mb-3">
                            <div className="col-sm-12 col-md-4 col-lg-4 col-xxl-4">
                                <DynamicInput placeholder={''} componentReadOnly={searchReadOnly} label={'Pesquisar Assunto'} name={'Search'} paramMethod={getSearch} />
                            </div>
                            <div className="col-sm-12 col-md-2 col-lg-2  pt-2">
                                <input type="button" className='default-button-red btn-block' value='Marcar Todos Lidos' onClick={setMarcarTodos} />
                            </div>
                        </div>
                        <StyledForm >
                            <div className='row justify-content-between'>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicSelect
                                        placeholder={''}
                                        valuetext={tipoAviso}
                                        label={'Tipo Aviso'}
                                        name={'tipoAviso'}
                                        options={tipoList}
                                        keyValue={'key'}
                                        keyLabel={'value'}
                                        paramMethod={getTipoAviso} clearOption={true} />
                                </div>
                                <div className="position-relative form-group col-sm-12 col-md-3 col-lg-3 p-2">
                                    <DynamicSelect
                                        placeholder={''}
                                        valuetext={exibicao}
                                        label={'Exibição'}
                                        name={'exibicao'}
                                        options={exibicaoList}
                                        keyValue={'key'}
                                        keyLabel={'value'}
                                        paramMethod={getExibicao} clearOption={true} />
                                </div>
                                <div className="position-relative col-sm-12  col-md-4 col-lg-4 pt-2">
                                    <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 pl-0" style={{ float: 'left' }}>
                                        <DatePicker
                                            dateFormat="dd/MM/yyyy"
                                            locale="pt-BR"
                                            className="input-form"
                                            selected={startDate}
                                            onChange={handleStartDateChange}
                                            placeholderText={'Data de início'}
                                        />
                                    </div>
                                    <div className="position-relative form-group col-sm-12 col-md-6 col-lg-6 pl-0" style={{ float: 'left' }}>
                                        <DatePicker
                                            dateFormat="dd/MM/yyyy"
                                            locale="pt-BR"
                                            className="input-form"
                                            selected={endDate}
                                            onChange={handleEndDateChange}
                                            placeholderText={'Data fim'}
                                        />
                                    </div>
                                </div>
                                <div className="position-relative form-group col-sm-2 col-md-2 col-lg-2 mt-2">
                                    <input type="button" className='default-button-red btn-block' value='Pesquisar' onClick={() => formData()} />
                                </div>
                            </div>
                        </StyledForm>
                        <StldRow>
                            <Flex>
                                <StyledForm style={{ width: "100%" }}>
                                    {isLoading ?
                                        <StldRow>
                                            <div className="text-center">
                                                <div className="align-items-center">
                                                    <div className="spinner-border ms-auto" style={{ color: "#EE4B21" }} role="status" aria-hidden="true"></div>
                                                    <div><strong style={{ color: "#EE4B21" }}>Pesquisando...</strong></div>
                                                </div>
                                            </div>
                                        </StldRow> : (
                                            <StyledTablePage>
                                                {
                                                    AvisosData != null && AvisosData?.data?.itens?.length > 0 ? (
                                                        AvisosData?.data?.itens?.map((avisoObject, index) => {

                                                            return (
                                                                <StldColumn key={index} xs="12" sm="6" md="4" lg="3" xl="3">
                                                                    <CardAvisos
                                                                        key={`A-${index}`}
                                                                        avisoObject={avisoObject}
                                                                        setMarcarLido={setMarcarLido}
                                                                    ></CardAvisos>
                                                                </StldColumn>
                                                            )
                                                        })

                                                    ) : (
                                                        AvisosData?.data?.itens?.length == 0 &&
                                                        <StldColumn xs="12" sm="12" md="12">
                                                            <div className="alert alert-warning" role="alert">
                                                                Atenção! Nenhum resultado encontrado!
                                                            </div>
                                                        </StldColumn>
                                                    )
                                                }
                                            </StyledTablePage>
                                        )
                                    }
                                </StyledForm>
                            </Flex>
                        </StldRow>
                        {(() => {
                            if (AvisosData != null) {
                                return (
                                    <PaginationCustom isMobile={isMobile}
                                        isDesktop={isDesktop}
                                        length={AvisosData?.data?.page?.length ?? 0}
                                        recordsTotal={AvisosData?.data?.page?.recordsTotal ?? 0}
                                        currentPage={currentPage ?? 0}
                                        formData={loadTable}
                                        pageSize={pageSize ?? 0}
                                        setPageSize={setPageSize}
                                        setPage={(page) => setCurrentPage(page)} />
                                )
                            }
                            return null
                        })()}
                    </div>
                </StyledDefaultPage>
            </main>

        </section>
    );
};

export const AvisosPage = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    return (
        <>
            {isMenuOpen ? (
                <MenuPage
                    isMenuOpen={isMenuOpen}
                    setIsMenuOpen={setIsMenuOpen}
                />
            ) : (
                <>
                    <Header
                        isMenuOpen={isMenuOpen}
                        setIsMenuOpen={setIsMenuOpen}
                    />
                    <Avisos />

                </>
            )}
        </>
    );
};
